<template>
  <Modal v-model="state.modal">
      <div class="text-c" v-if="state.loading">
        <AppLoader />
        <h2>Flytter ruten...</h2>
      </div>

      <div class="text-c" v-else-if="state.success">
        <AppIcon name="check" color="success" style="display:inline-flex;font-size:3rem;" outlined />
        <h2>Sådan!</h2>
        <p>Hvis bare det var så nemt at flytte lejlighed...</p>
        <p><b>Bemærk, at ruten har fået et nyt link!</b></p>
      </div>

      <div class="text-c" v-else>
        <h2>Kan ikke flytte ruten</h2>
        <div class="text-B color-error">{{ state.error }}</div>
        <br>
        <div class="flex flex-c">
          <AppButton color="primary" style="margin-left:.5rem" v-if="state.errorReason == 'limit'" @click="$router.push('/account')">Opgradér og få plads til 10 ruter</AppButton>
        </div>
        <div class="divider"></div>
        <p><small>Hvis du mener ovenstående er forkert, <br> så <a href="mailto:hello@tripply.dk" target="_blank">skriv til os her</a></small></p>
      </div>

      <template v-slot:footer v-if="!state.loading && !state.success">
        <a target="_blank" :href="'https://old.tripply.dk/trips'"><AppButton color="secondary">Tilbage</AppButton></a>
        <AppButton color="primary" @click="$router.push('/routes')" style="margin-left:1rem;">Afslut flytning</AppButton>
      </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, computed, PropType, reactive, onMounted } from 'vue'
import { store } from '@/store'
import { getOldRoute, OldRoute, OldWaypoint } from '@/services/migration.service'
import router from '@/router'
import { CoordinatesModel, LocationModel, PlaceModel } from '@/api/tripply/models'
import { sortArray } from '@/api/tools'
import { db } from '@/api/firebase'
import { GA } from '@/api/analytics'

export default defineComponent({
  name: 'Migration',
  setup(props) {
    const state = reactive({
      modal: true,
      loading: true,
      success: false,
      error: '',
      errorReason: '',
      route: {} as OldRoute
    })

    onMounted(() => {
      setTimeout(async () => {
        const oldRouteId = router.currentRoute.value.params.id as string
        const oldUserId = router.currentRoute.value.params.uid as string
        const route = await getOldRoute(oldRouteId)
        state.route = route
        try {
          if (route.creator.uid !== oldUserId) {
            state.errorReason = 'permission'
            throw 'Du har ikke rettigheder til at flytte denne rute.'
          }
          state.errorReason = 'limit'
          const routeId = store.route.createRoute({
            name: route.name,
            custom: route.settings.method == 'custom',
            breakTime: parseInt(route.settings.breakTime) * 60,
            startTime: route.settings.startTime,
            startDate: '',
            timeLimit: 0,
            type: 'AB',
            vehicle: route.settings.vehicle,
            private: false,
            method: route.settings.method == 'custom' ? 'custom' : 'fastest',
            detailed: false
          }, true)
          if (routeId) {
            const waypoints = sortArray<OldWaypoint>(Object.values(route.waypoints), 'index')
            const locations = waypoints.map(wp => new LocationModel(wp.address, new CoordinatesModel(wp.lat,wp.lon), '', wp.name))
            const places = Object.values(locations).map(location => new PlaceModel(location))
            const excessPlaces = places.length - (store.user.permission('LIMIT_ROUTE_PLACES') as number)
            if (excessPlaces > 0) {
              store.global.toast({
                title: excessPlaces + ' stop på ruten blev udeladt.',
                msg: 'Ruten du forsøger at flytte har for mange stop. Opgradér til Tripply Plus for at flytte hele ruten.',
                type: 'warning',
                time: 10000
              })
            }
            await store.route.addPlaces(routeId, places.slice(0, store.user.permission('LIMIT_ROUTE_PLACES') as number))
            store.route.mutate(state => state.routes[routeId].migrationId = oldRouteId)
            GA('migration', { status: 'success' })
            await store.route.saveRoute(routeId)
            state.success = true
            state.loading = false
            setTimeout(() => {
                router.push('/routes')
            }, 3000)
          }
        } catch(err) {
          state.loading = false
          state.error = err
          GA('migration', { status: 'error', error: err })
        }
      }, 1000)
    })
    
    return { store, state }
  }
})
</script>

<style lang="scss" scoped>

</style>